module.exports = {"Contract":"Контракт","Client":"Заемщик","EventPlan":"Мероприятие","Receipt":"Платеж"};